import {
  REMOVE_BLOCK,
  REMOVE_BLOCK_CLEAN,
  REMOVE_BLOCK_SUCCESS,
  REMOVE_BLOCK_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  lesson: undefined,
}

const BlockRemove = (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_BLOCK:
      state = {
        ...state,
        loading: true,
      }
      break
    case REMOVE_BLOCK_SUCCESS:
      state = {
        ...state,
        loading: false,
        done: true,
        block: action.payload.block,
      }
      break
    case REMOVE_BLOCK_CLEAN:
      state = initialState
      break
    case REMOVE_BLOCK_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default BlockRemove
